import React from "react";
import { accessToken, logout } from "./auth.js";
import { clearInvitation, invitationIsCurrent, INVITATION_MAX_AGE } from "./invitation_session.js";

export function InvitationRedeem({ invitation }) {
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState("");
  const [refused, setRefused] = React.useState(false);
  const expire = () => {
    clearInvitation(); setRefused(true);
    setError("This invitation has been open for 15 minutes. Reopen the original email link to continue.");
  };
  React.useEffect(() => {
    const timer = window.setTimeout(expire, Math.max(0, invitation.at + INVITATION_MAX_AGE - Date.now()));
    return () => window.clearTimeout(timer);
  }, [invitation.at]);
  const accept = async () => {
    if (busy || refused) return;
    if (!invitationIsCurrent(invitation)) { expire(); return; }
    setBusy(true); setError("");
    try {
      const bearer = await accessToken();
      if (!bearer) { setError("Sign in again, then reopen your invitation link."); return; }
      if (!invitationIsCurrent(invitation)) { expire(); return; }
      // Do not carry the currently selected realm into this token ceremony.
      const response = await fetch("/actions/foundation.owner_invitations.redeem@1/", {
        method: "POST", credentials: "omit",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${bearer}` },
        body: JSON.stringify({ input: { token: invitation.token }, idempotency_key: invitation.key }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        if ([400,404,410].includes(response.status)) {
          clearInvitation(); setRefused(true);
          setError("This invitation cannot be used with this account. Check the invited email address, or ask Inglis for a new link.");
        } else setError("We could not verify this invitation just now. Check that your email is verified, then try again.");
        return;
      }
      if (typeof result.realm !== "string" || !result.realm) throw new Error("invalid_response");
      clearInvitation();
      window.location.assign(`/?realm=${encodeURIComponent(result.realm)}`);
    } catch { setError("The result could not be confirmed. Try again with this invitation."); }
    finally { setBusy(false); }
  };
  return <div className="boot-state"><h1>Vendor Owner invitation</h1>
    <p>Accept this invitation to manage the vendor’s dashboard. Sign in with the verified email address the invitation was sent to.</p>
    {error && <p role="alert">{error}</p>}
    <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap"}}>
      <button type="button" className="btn primary" disabled={busy || refused} onClick={accept}>{busy ? "Accepting…" : "Accept invitation"}</button>
      <button type="button" className="btn" disabled={busy} onClick={() => { clearInvitation(); window.location.assign("/"); }}>Cancel</button>
      <button type="button" className="btn" disabled={busy} onClick={() => { clearInvitation(); logout(); }}>Sign out</button>
    </div></div>;
}
